/* global System */

export default {
  EstatePage: () =>
    System.import(/* webpackChunkName: "EstatePage" */ './index'),
}
